module.exports = __webpack_public_path__ + "static/media/disappointed-emoji.66f7554a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/disappointed-emoji.png
// module id = 300
// module chunks = 0